import React from 'react'
import { IWebinar } from './index'
import { WebinarHero } from './hero/hero-legacy'
import { WebinarsDetails } from '../../../library/elements/WebinarsDetails'
import { ScheduledWebinars } from './scheduled'
import { RecordedWebinars } from './recorded'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import * as Utils from 'marketing-site/src/library/utils'
import styles from './style.scss'

type IProps = IWebinar & { relatedWebinars: IWebinar[] }

export function Webinar(props: IProps) {
  return (
    <div className="webinars__wrap webinars__wrap-single">
      <WebinarHero {...props} />
      <WebinarsDetails {...props} />
      {props.relatedWebinars.length ? (
        props.isRecording ? (
          <RecordedWebinars
            heading="Related Webinars"
            webinars={props.relatedWebinars}
            searchEnabled={false}
          />
        ) : (
          <ScheduledWebinars heading="Related Webinars" webinars={props.relatedWebinars} />
        )
      ) : null}
      <div className="webinar__learn-more">
        <CTALink
          bgColor={Utils.CTATheme.BlackFill}
          text="Explore more webinars"
          url="/webinars"
          newWindow={false}
        />
      </div>
      <style jsx>{styles}</style>
      <style jsx global>
        {`
          main {
            padding-top: 0 !important;
          }

          @media (min-width: 768px) {
            main {
              padding-top: 20px !important;
            }
          }
        `}
      </style>
    </div>
  )
}
